export default __webpack_public_path__ + "assets/fonts/Inter-ExtraBold.woff2";